import { render, staticRenderFns } from "./SignatariosWhatsappAsinandoTabela.vue?vue&type=template&id=23fcf820"
import script from "./SignatariosWhatsappAsinandoTabela.vue?vue&type=script&lang=js"
export * from "./SignatariosWhatsappAsinandoTabela.vue?vue&type=script&lang=js"
import style0 from "./SignatariosWhatsappAsinandoTabela.vue?vue&type=style&index=0&id=23fcf820&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports